<template>
  <div style="display: flex">
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
      <path
          d="M8.73779 2.75C9.29698 2.75 9.75029 3.20331 9.75029 3.7625V6.09381C9.75029 6.31814 9.56843 6.5 9.3441 6.5C9.14553 6.5 8.97607 6.35645 8.94343 6.16058L8.66468 4.48808C8.63832 4.32993 8.63108 4.16919 8.6431 4.00932L8.73779 2.75Z"
          fill="currentColor"/>
      <path
          d="M8.7375 2.75C9.29669 2.75 9.75 3.20331 9.75 3.7625L8.49049 3.85696C8.33074 3.86894 8.17013 3.86169 8.01211 3.83535L6.33928 3.55655C6.1435 3.52392 6 3.35452 6 3.15604C6 2.93179 6.18179 2.75 6.40604 2.75L8.7375 2.75Z"
          fill="currentColor"/>
      <rect x="4.91016" y="6.875" width="5.41795" height="1.0125" rx="0.50625" transform="rotate(-45 4.91016 6.875)"
            fill="currentColor"/>
      <path
          d="M5.25 3.25625C5.25 2.97666 5.02334 2.75 4.74375 2.75H4.5C3.25736 2.75 2.25 3.75736 2.25 5V8C2.25 9.24264 3.25736 10.25 4.5 10.25H7.5C8.74264 10.25 9.75 9.24264 9.75 8V7.75625C9.75 7.47666 9.52334 7.25 9.24375 7.25C8.96416 7.25 8.7375 7.47666 8.7375 7.75625V8C8.7375 8.68345 8.18345 9.2375 7.5 9.2375H4.5C3.81655 9.2375 3.2625 8.68345 3.2625 8V5C3.2625 4.31655 3.81655 3.7625 4.5 3.7625H4.74375C5.02334 3.7625 5.25 3.53584 5.25 3.25625Z"
          fill="currentColor"/>
    </svg>
  </div>
</template>